<template>
<div class="chapter">
<div class="inner_page">
<p class="C1657"><span class="small"><span id="page_v">CONTENTS</span></span></p>
<p class="C1659"><em><a href="#/html/05_Preface#page_vii">Preface</a> </em><span class="small">BY JAMES R. AKERMAN</span></p>
<p class="C1667"><a href="#/html/06_Introduc#page_1">Introduction</a> <em>by Richard J. A. Talbert</em></p>
<p class="C1660"><a href="#/html/07_1__The_E#page_9">1. The Expression of Terrestrial and Celestial Order in Ancient Mesopotamia</a> <em>by Francesca Rochberg </em></p>
<p class="C1667"><span href="#/html/08_2__From#page_43" title="Link target outside of Sample">2. From Topography to Cosmos: Ancient Egypt’s Multiple Maps</span> <em>by David O’Connor </em></p>
<p class="C1667"><span href="#/html/09_3__Mappi#page_81" title="Link target outside of Sample">3. Mapping the World: Greek Initiatives from Homer to Eratosthenes</span> <em>by Georgia L. Irby </em></p>
<p class="C1667"><span href="#/html/10_4__Ptole#page_109" title="Link target outside of Sample">4. Ptolemy’s Geography: Mapmaking and the Scientific Enterprise</span> <em>by Alexander Jones </em></p>
<p class="C1667"><span href="#/html/11_5__Greek#page_129" title="Link target outside of Sample">5. Greek and Roman Surveying and Surveying Instruments</span> <em>by Michael Lewis </em></p>
<p class="C1667"><span href="#/html/12_6__Urbs#page_163" title="Link target outside of Sample">6. <em>Urbs Roma </em>to <em>Orbis Romanus</em>: Roman Mapping on the Grand Scale</span> <em>by Richard J. A. Talbert </em></p>
<p class="C1667"><span href="#/html/13_7__Putti#page_193" title="Link target outside of Sample">7. Putting the World in Order: Mapping in Roman Texts</span> <em>by Benet Salway </em></p>
<p class="C1660"><em><span href="#/html/notes#note" title="Link target outside of Sample">Notes</span></em></p>
<p class="C1647"><em><span href="#/html/14_Bibliogr#page_234" title="Link target outside of Sample">Bibliography</span></em></p>
<p class="C1647"><em><span href="#/html/15_Contribu#page_251" title="Link target outside of Sample">Contributors</span></em></p>
<p class="C1647"><em><span href="#/html/16_Index#page_253" title="Link target outside of Sample">Index</span></em></p>
<p class="C1647"><em><span href="#/html/plate" title="Link target outside of Sample">Plate Section</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?58d0ce74